import { TFunction } from '@lyearn/i18n';
import { UpdateQuestionEntity } from '@/types/schema';

const validateFillInTheBlanks = (t: TFunction, question?: UpdateQuestionEntity) => {
  const blanks = question?.ftbComponents?.set.filter((component) => component.isBlank) || [];

  if (blanks.length < 1) {
    return {
      message: t('QuizCreator:Validations.AtleastOneBlankRequired'),
      type: 'AtleastOneBlankRequired',
    };
  }

  const isAnyBlankEmpty = blanks.findIndex((blank) => !Boolean(blank.text)) !== -1;
  if (isAnyBlankEmpty) {
    return {
      message: t('QuizCreator:Validations.BlanksCannotBeEmpty'),
      type: 'BlanksCannotBeEmpty',
    };
  }

  const isAnyIncorrectOptionEmpty =
    question?.globalDistractors?.set.findIndex((distractor) => !Boolean(distractor.text)) !== -1;
  if (isAnyIncorrectOptionEmpty) {
    return {
      message: t('QuizCreator:Validations.DistractorCantBeEmpty'),
      type: 'QuestionSettings',
    };
  }
};

export default validateFillInTheBlanks;
